import { useEffect, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";

function QRScanQRCodeScanning() {
  const [scannedData, setScannedData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const scanner = new Html5Qrcode("qr-reader");
    const config = { fps: 40, qrbox: 250 };

    scanner
      .start(
        { facingMode: "environment" },
        config,
        (decodedText) => {
          try {
            const parsed = JSON.parse(decodedText);
            console.log("✅ Scanned and parsed:", parsed);
            setScannedData(parsed);

            // Optional: stop scanning
            scanner.stop();
          } catch (e) {
            console.error("❌ Invalid JSON format in QR:", decodedText);
            setError("Scanned data is not valid JSON.");
          }
        },
        (err) => {
          console.warn("Scan error:", err);
          setError("Scan error. Try again.");
        }
      )
      .catch((err) => {
        console.error("Scanner failed to start:", err);
        setError("Could not start scanner.");
      });

    return () => {
      scanner.stop().catch((err) => console.log("Stop failed:", err));
    };
  }, []);

  return (
    <div>
      <h2>QR Code Scanner (HTML5)</h2>
      <div id="qr-reader" style={{ width: "300px", height: "300px" }}></div>

      {scannedData && (
        <div style={{ marginTop: "1rem" }}>
          <h3>Scanned Data</h3>
          <pre>{JSON.stringify(scannedData, null, 2)}</pre>
        </div>
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
}

export default QRScanQRCodeScanning;
